import React, { useState } from "react";
import SimpleLoadingIndicator from "../../../../../../components/simple-loading-indicator/index.tsx";
import CardLeft from "./components/card-left.tsx";
import CardRight from "./components/card-right.tsx";
import ViewerLeft from "./components/viewer-container-left.tsx";
import ViewerRight from "./components/viewer-container-right.tsx";

const OverlayPlanViewerLayout: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <div className="relative flex-1">
            <CardLeft/>
            <CardRight/>

            <div className='absolute inset-0 grid grid-cols-2 divide-x divide-gray-300'>
                <ViewerLeft setIsLoading={setIsLoading}/>
                <ViewerRight setIsLoading={setIsLoading}/>
            </div>

            {isLoading &&
                <SimpleLoadingIndicator text="Chargement des plans" className='m-auto'/>
            }
        </div>
    )
}

export default OverlayPlanViewerLayout;